import type { AllRouteEndpoints } from "../routeTypes";

export const alloysPartnersAlloysIdBreakingChangesExportCacheKeys: AllRouteEndpoints[] = [];
